// Client-side detector for a privacy-gated scorecard row (F-039).
//
// The server (get_standalone_scores) enforces the outbound friend-privacy gate
// by NULLING hole_scores for a friend who hasn't opted into sharing their
// per-hole scorecard (default OFF). Gross total and score-vs-par are NOT gated
// and still come back on the row. The RoundLeaderboardPage mapper then turns a
// null hole_scores into {} — so a gated row reaches render as an EMPTY hole map
// alongside a real gross total.
//
// Without this detector the page drew an all-empty per-hole grid (every cell
// '–') with no explanation — a silent blank scorecard. This predicate lets the
// page render an explicit "keeps their scorecard private" empty-state for that
// row while STILL showing the (ungated) gross total and +/- vs par.
//
// Detection: an empty hole map + a real gross total means the server withheld
// the holes. A genuinely un-started round also has an empty hole map, but no
// gross total (null/0), so it is NOT treated as gated — it renders normally.
// A client-computed team row (best-ball / scramble) carries synthesized member
// data and is never gated.
export function isScorecardPrivacyGated(row) {
  if (!row) return false
  // Client-computed team rows are aggregates, never a server-gated friend row.
  if (row._bestball_members) return false
  const hs = row.hole_scores
  const holeCount = hs && typeof hs === 'object' ? Object.keys(hs).length : 0
  if (holeCount > 0) return false
  // Empty hole map WITH a real gross total => the server nulled the scorecard.
  return row.gross_total != null && row.gross_total !== 0
}
